import * as o from "react";
import t from "../lib/SSRBase.es.js";
import c from "../defs/ArrowClockwise.es.js";
const r = o.forwardRef((e, s) => /* @__PURE__ */ o.createElement(t, { ref: s, ...e, weights: c }));
r.displayName = "ArrowClockwiseIcon";
const m = r;
export {
  m as ArrowClockwise,
  r as ArrowClockwiseIcon
};
